import React from 'react'
import ReactSelect from 'react-select'
import { Controller } from 'react-hook-form'

export function Select({ control, options, name, label = '', ...rest }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <label>
          {label}
          <ReactSelect
            onChange={({ value: newValue }) => onChange(newValue)}
            options={options}
            {...rest}
          />
        </label>
      )}
    />
  )
}
